import {isFont} from '../utils/observeResources.js';
import collectResources from '../utils/collectResources.js';

export default function fonts(state) {
    return collectResources(state, 'fonts', {filter: isFont});
}
